<template>
  <el-card shadow="never" :body-style="{ padding: '10px' }">
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      @reload="() => this.$emit('refresh')"
    >
      <template #toolbar_btn v-if="allow('E')">
        <div class="dowClass">
          <i
            style="padding-right: 1px;"
            class="el-icon-bottom tool-btn"
            @click="$emit('exportFile', { type: 'dep' })"
          ></i>
        </div>
      </template>
    </Main>
  </el-card>
</template>
<script>
import Main from './main'
export default {
  components: { Main },
  props: {
    form: { type: Object, default: () => {} },
  },
  data() {
    return {
      tableData: [],
      loading: false,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.getData(val)
      },
      immediate: true,
    },
  },
  methods: {
    getData(queryform) {
      this.loading = true
      this.tableData = []
      this.$api.orderBudgetAnalysisListDepApi(queryform).then((res) => {
        this.loading = false
        this.tableData = res.body.data
      })
    },
    refresh() {
      this.$emit('queryListDep')
    },
  },
}
</script>
<style lang="scss" scoped>
// .el-card__body {
//   padding: 10px !important;
// }
.dowClass {
  border: solid 1px #dcdfe6;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin-right: 0.8em;
}
</style>
